module.exports = __webpack_public_path__ + "static/img/logo_loading.8d181170.png";